import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {NavLink} from 'react-router-dom'

// Ссылки верхнего меню сервиса.
// Не отображаются на мобильных экранах.
export function PublicLinks() {

    return (
        <nav
            className={clsx(
                'top-nav-links',
                'd-flex flex-row align-items-center flex-1'
            )}
        >
            <NavLink
                to={appUrl().about}
            >
                {trans().common.top_navigation.about_project}
            </NavLink>
            <NavLink
                to={appUrl().support.rulesAndDocuments}
            >
                {trans().common.top_navigation.rules}
            </NavLink>
            <NavLink
                to={appUrl().support.index}
                className="d-none d-xl-inline"
            >
                {trans().common.top_navigation.support}
            </NavLink>
        </nav>
    )
}
